// extracted by mini-css-extract-plugin
export default {"storeCard":"StoreCard_storeCard__6Q1tg","storeImg":"StoreCard_storeImg__gPZvv","storeText":"StoreCard_storeText__BIllY","storeDesc":"StoreCard_storeDesc__FZnMX"};